import React, {Component} from 'react';

import styles from './Content.css'

export default class Content extends Component {
    render() {

        const {padding} = this.props;

        let classes = styles.content;
        if(padding === false) {
            classes = null;
        }

        return (
            <div className={classes}>{this.props.children}</div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/Content.js